// Module
var code = `<div class="modal-dialog">
  <div class="modal-content">
    <button type="button" class="btn p-0 btn-close" data-bs-dismiss="modal" aria-label="Close">x</button>
    <div ng-include="\$ctrl.modalinc"></div>
  </div>
</div>`;
// Exports
module.exports = code;